import React, { Component } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import {
  PurchasesModule,
  InventoryModule,
  OrdersManagementModule,
  DeliveryManagementModule,
  PackagingManagementModule,
  ReportsModule,
  AccountingModule,
  CrmModule,
  HrmModule,
  RawMaterialsModule,
  RetailPosModule,
  DemoButton,
  DigitalCatalogModule,
  LeadsManagementModule,
  QuoteManagementModule,
  SalesOrderModule,
  SuppliersModule,
  ProductionModule,
} from "./CommonModules";

import CartContext from "./CartContext";

export class Warehouse extends Component {
  static contextType = CartContext;

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleTryNow = () => {
    const {
      userData,
      ShowUserLoginNew,
      SetSelectedProduct,
      prods,
      ProductType,
    } = this.context;

    if (!userData || userData.loginStatus !== "active") {
      if (typeof ShowUserLoginNew === "function") ShowUserLoginNew(true);
      return;
    }

    if (Array.isArray(prods) && ProductType) {
      const selected = prods.find(
        (p) =>
          p.productType === ProductType.Retail_ERP ||
          p.productType === ProductType.Warehouse_ERP
      );
      if (selected && typeof SetSelectedProduct === "function") {
        SetSelectedProduct(selected);
      }
    }
  };

  render() {
    if (
      !this.context ||
      !this.context.EcSettings ||
      this.context.EcSettings.length === 0
    ) {
      return <></>;
    }

    const base = this.context.GetEcSettingValueByName
      ? this.context.GetEcSettingValueByName("StorageBlobImageUrl")
      : "";

    return (
      <>
        {/* Hero / WMS Marketing Section */}
        <section className="hero container-fluid py-5 bg-white" id="wmsSection">
          <div className="container">
            <div className="row align-items-center gy-4">
              <div className="col-lg-7">
                <span className="badge-sub">
                  Warehouse & Inventory Management
                </span>

                <h1 className="display-5 fw-bold mt-3">
                  WMS & Inventory ERP — Control stock, streamline operations and
                  deliver on time
                </h1>

                <p className="lead text-muted mb-4">
                  Manage warehouses, track inventory in real-time, improve
                  picking accuracy, and integrate seamlessly with purchasing,
                  sales and logistics — all in one platform.
                </p>

                <p className="mb-4">
                  <strong>Why choose ElasticCART WMS?</strong>
                </p>

                <div className="row g-3">
                  <div className="col-sm-6">
                    <div className="d-flex gap-3 align-items-start">
                      <div className="feature-icon">
                        <i className="fa-solid fa-warehouse" />
                      </div>
                      <div>
                        <h6 className="mb-1">Multi-warehouse Control</h6>
                        <small className="text-muted">
                          Centralized control for multiple warehouses &
                          locations.
                        </small>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="d-flex gap-3 align-items-start">
                      <div className="feature-icon">
                        <i className="fa-solid fa-barcode" />
                      </div>
                      <div>
                        <h6 className="mb-1">Barcode & RFID</h6>
                        <small className="text-muted">
                          Faster receiving, picking & stock accuracy with scans.
                        </small>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="d-flex gap-3 align-items-start">
                      <div className="feature-icon">
                        <i className="fa-solid fa-cubes" />
                      </div>
                      <div>
                        <h6 className="mb-1">Lot & Serial Tracking</h6>
                        <small className="text-muted">
                          Traceability across raw materials and finished goods.
                        </small>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="d-flex gap-3 align-items-start">
                      <div className="feature-icon">
                        <i className="fa-solid fa-truck-fast" />
                      </div>
                      <div>
                        <h6 className="mb-1">Picking & Shipping</h6>
                        <small className="text-muted">
                          Optimized pick-pack-ship workflows & carrier
                          integration.
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-4">
                  {/* <Button
                    variant="light"
                    size="lg"
                    className="me-2"
                    onClick={this.handleTryNow}
                  >
                    <i className="fa-solid fa-play me-2" /> Book a demo
                    +91-98805 82728
                  </Button> */}

                  <Button
                    variant="primary"
                    size="lg"
                    as={Link}
                    to="/Checkout"
                    onClick={() =>
                      this.context.HandleTryNowButtonClick(
                        this.context.ProductType.WarehouseManagement
                      )
                    }
                  >
                    <i className="fa-solid fa-flask me-2" /> Start free trial
                  </Button>
                </div>
              </div>

              <div className="col-lg-5">
                <div className="card card-feature p-4">
                  <div className="card-body">
                    <h5 className="card-title mb-3">Core WMS capabilities</h5>
                    <div className="row">
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-inbox fa-lg me-2" />
                        <strong>Receiving</strong>
                        <div className="text-muted small">
                          PO-based receiving, ASN & putaway.
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-layer-group fa-lg me-2" />
                        <strong>Stock Control</strong>
                        <div className="text-muted small">
                          Bins, racks, cycle counting & adjustments.
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-box-open fa-lg me-2" />
                        <strong>Picking</strong>
                        <div className="text-muted small">
                          Batch, wave & zone picking methods.
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-route fa-lg me-2" />
                        <strong>Shipping</strong>
                        <div className="text-muted small">
                          Carrier integrations, label printing & tracking.
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-chart-line fa-lg me-2" />
                        <strong>Analytics</strong>
                        <div className="text-muted small">
                          Stock turns, fill-rate & order cycle time.
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-shield-halved fa-lg me-2" />
                        <strong>Accuracy & Control</strong>
                        <div className="text-muted small">
                          Audit trails, permissions & real-time updates.
                        </div>
                      </div>
                    </div>

                    {/* <div className="mt-3">
                      <Button
                        variant="primary"
                        size="sm"
                        as={Link}
                        to="#features"
                      >
                        See full feature list
                      </Button>
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        as={Link}
                        to="#contact"
                        className="ms-2"
                      >
                        Contact sales
                      </Button>
                    </div> */}
                    <DemoButton></DemoButton>
                  </div>
                </div>
              </div>

              {/* Product overview text */}
              <div className="col-12 mt-4">
                <div>
                  ElasticCART WMS helps you gain{" "}
                  <strong>real-time inventory visibility</strong>, reduce
                  operational costs and ensure{" "}
                  <strong>on-time in-full deliveries</strong>. From inbound
                  logistics to outbound shipping, everything is streamlined and
                  connected.
                </div>
              </div>

              {/* Demo Video */}
              {/* <div className="col-lg-12 mb-lg-5 py-5">
                <video
                  controls
                  height="400px"
                  autoPlay
                  muted
                  loop
                  width="100%"
                  aria-label="WMS demo video"
                >
                  <source
                    src={base + "WarehouseErpVideo.mp4"}
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div> */}
            </div>

            {/* Modules short list */}
            <div className="row mt-5 modules">
              <div className="col-lg-8">
                <div className="card border-0 shadow-sm">
                  <div className="card-body">
                    <h4 className="mb-3">What we cover</h4>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <ul className="list-unstyled">
                          <li>
                            <strong>Receiving & Putaway:</strong> ASN, PO-based
                            receiving, putaway rules.
                          </li>
                          <li>
                            <strong>Inventory Tracking:</strong> lot/serial,
                            expiry, stock movements.
                          </li>
                          <li>
                            <strong>Picking & Packing:</strong> wave picking,
                            batch picking, cartonization.
                          </li>
                          <li>
                            <strong>Cycle Counting:</strong> stock audits, blind
                            counts, variance reporting.
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <ul className="list-unstyled">
                          <li>
                            <strong>Warehouse Layout:</strong> bins, racks,
                            zones, location management.
                          </li>
                          <li>
                            <strong>Returns & Reverse Logistics:</strong> RMAs,
                            inspection, put-back rules.
                          </li>
                          <li>
                            <strong>Integration:</strong> ERP, POS, ecommerce &
                            accounting systems.
                          </li>
                          <li>
                            <strong>KPIs & Reports:</strong> stock turns, fill
                            rate, cycle time analytics.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="cta-strip text-center p-4 rounded">
                  <h5 className="mb-2">Upgrade to smart warehousing</h5>
                  <p className="mb-3 small text-muted">
                    Book a demo and see how ElasticCART WMS improves inventory
                    accuracy and speeds up fulfillment.
                  </p>
                  {/* <Button
                    variant="light"
                    size="sm"
                    className="me-2"
                    onClick={this.handleTryNow}
                  >
                    <i className="fa-solid fa-calendar-check me-2" /> Book a
                    demo
                  </Button> */}
                  {/* <Button
                    variant="outline-light"
                    size="sm"
                    as={Link}
                    to="/Checkout"
                    onClick={() =>
                      this.context.HandleTryNowButtonClick(
                        this.context.ProductType.WarehouseManagement
                      )
                    }
                  >
                    <i className="fa-regular fa-clock me-2" /> Start free trial
                  </Button> */}
                  <DemoButton></DemoButton>
                </div>

                <div className="card mt-3 border-0">
                  <div className="card-body small text-muted">
                    <strong>Trusted by:</strong>
                    <div className="mt-2 d-flex gap-2 flex-wrap">
                      <span className="badge bg-light text-dark">Retail</span>
                      <span className="badge bg-light text-dark">
                        Distribution
                      </span>
                      <span className="badge bg-light text-dark">
                        Manufacturing
                      </span>
                      <span className="badge bg-light text-dark">3PL</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer CTA */}
            <div className="row mt-5">
              <div className="col-12 text-center">
                <p className="text-muted small mb-2">
                  See WMS in action — 30-minute demo, no obligation.
                </p>
                <DemoButton></DemoButton>
                {/* <Button
                  variant="outline-primary"
                  size="lg"
                  className="me-2"
                  onClick={this.handleTryNow}
                >
                  Book a demo +91-98805 82728
                </Button>
                <Button variant="primary" size="lg" as={Link} to="#contact">
                  Contact sales
                </Button> */}
              </div>
            </div>
          </div>
        </section>

        {/* WMS Modules Section */}
        <section className="container my-5">
          <h5 className="display-6 text-dark mb-4 border-start border-5 border-primary ps-3 py-5">
            Explore WMS Modules That Power Your Warehouse
          </h5>
          <Row className="g-3">
            {[
              RawMaterialsModule,
              PurchasesModule,
              SuppliersModule,
              ProductionModule,
              InventoryModule,
              OrdersManagementModule,
              PackagingManagementModule,
              DeliveryManagementModule,
              CrmModule,
              DigitalCatalogModule,
              LeadsManagementModule,
              QuoteManagementModule,
              SalesOrderModule,
              RetailPosModule,
              AccountingModule,
              HrmModule,
              ReportsModule,
            ].map((Module, index) => (
              <Col md={6} lg={6} key={index}>
                <div className="bg-light p-3 rounded shadow-sm h-100 hover-shadow">
                  {Module ? <Module /> : <div className="p-3">Module</div>}
                </div>
              </Col>
            ))}
          </Row>
        </section>
      </>
    );
  }
}

export default Warehouse;
